










































import {
    BooleanFieldModel,
    FieldValueCollectionEditViewModel,
    IAddress,
    ListFieldModel,
    TextFieldModel,
    typeDependencies,
} from "chipply-common";
import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
@typeDependencies({
    types: {
        BooleanFieldModel,
        TextFieldModel,
        ListFieldModel,
    },
})
export default class FieldValueCollectionEditor extends Vue {
    public BooleanFieldModel = BooleanFieldModel;
    public ListFieldModel = ListFieldModel;
    public TextFieldModel = TextFieldModel;
    public isValid = false;

    @Prop({ type: Object, default: null })
    public viewModel!: FieldValueCollectionEditViewModel;

    @Prop({ type: Boolean, default: false })
    public outlined!: boolean;

    // public realViewModel: any | null = this.viewModel;
    //
    // @Watch("viewModel")
    // public viewModelChanged() {
    //   this.realViewModel = this.viewModel;
    // }

    public requireValueBoolean(value: any) {
        if (value !== null) {
            return true;
        }
        return "You must enter a value";
    }

    public requireValue(value: any) {
        const num = parseFloat(value);
        if (!Number.isNaN(num)) {
            return true;
        }

        if ((value || "").length > 0) {
            return true;
        }
        return "You must enter a value";
    }

    @Watch("viewModel", { deep: true, immediate: true })
    onViewModelChanged() {
        this.$nextTick(() => {
            if (this.$refs.fieldForm) {
                const valid = (this.$refs.fieldForm as any).validate();
                this.isValid = valid;
                this.$emit("validation-changed", valid);
            }
        });
    }

    public validate() {
        return (this.$refs.fieldForm as any)?.validate();
    }
}
